import { useMutation } from '@tanstack/react-query';

import {
  gqlClient,
  graphql,
  type Notes_UpsertNote,
  queryClient,
  resolveBackendError,
} from '@tyro/api';
import { toast } from '@tyro/core/toaster';
import { useTranslation } from '@tyro/i18n';
import { reportsKeys } from '@tyro/reporting/api/keys';
import { peopleKeys } from '../keys';

const upsertNote = graphql(/* GraphQL */ `
  mutation notes_upsertBehaviourNote($input: [Notes_UpsertNote]) {
    notes_upsertNotes(input: $input) {
      id
      tags {
        behaviourType
      }
    }
  }
`);

export function useUpsertStudentBehaviour() {
  const { t } = useTranslation(['common']);

  return useMutation({
    mutationFn: async (input: Notes_UpsertNote[]) =>
      gqlClient.request(upsertNote, { input }),
    onSuccess: async (_, [note]) => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: peopleKeys.students.all() }),
        queryClient.invalidateQueries({ queryKey: reportsKeys.all }),
      ]);

      toast.success(
        note.id
          ? t('common:snackbarMessages.updateSuccess')
          : t('common:snackbarMessages.createSuccess'),
      );
    },
    onError: async (error: unknown) => {
      const description = await resolveBackendError(error);
      toast.error(t('common:snackbarMessages.errorFailed'), { description });
    },
  });
}
